import { DataSourceMode, DataSourceModeChangeEvent, LookupModelSearchEvent } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutMobileCommControlSendLoad } from "./autogen/AutogenLayoutMobileCommControlSendLoad";

export class MobileCommControlSendLoad extends AutogenLayoutMobileCommControlSendLoad {

    async onLoad() {
        this.setupEventListeners();
    }

    textboxDispatchFormBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.form_type = "O";

        if (this.owner.mainDataSource?.activeRow?.get("id")) {
            event.filter.mc_control_id = this.owner.mainDataSource.activeRow.get("id");
        }
    }

    private setupEventListeners(): void {
        // Set up data source listeners
        if (this.sourceMCControl) {
            this.sourceMCControl.addAfterModeChangeListener(this.onModeChange.bind(this));
        }
    }

    private onModeChange(event: DataSourceModeChangeEvent): void {
        const mode = event.newMode;

        switch (mode) {
            case DataSourceMode.ADD:
                this.setDefaultZmitFormValues();
                break;
        }
    }

    private setDefaultZmitFormValues(): void {

        if (!this.textboxDispatchForm?.lookupModel) {
            return;
        }

        // Create a model row for the default value (id: 0)
        const defaultModelRow = new ModelRow(this.textboxDispatchForm.lookupModel, false, { "id": 0, "title": "Freeform" });

        // List of form fields to set to default value
        const formFields = [
            "dispatch_form",
            "directions_form",
            "route_form",
            "wire_form",
            "empty_form",
            "stops_form"
        ];

        // Set default values for all form fields
        formFields.forEach(field => {
            this.mainDataSource.activeRow?.setValueAndLookupModelData(field, 0, defaultModelRow);
        });
    }
}
